import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TaskLabel } from "app/frontend/lib/taskbook-triage/taskbook.types";


@Component({
    selector: 'task-labels',
    templateUrl: './task-labels.component.html',
    standalone: false
})
export class TaskLabelsComponent {

    @Input() labels: TaskLabel[];
    @Output() onLabelChange = new EventEmitter<TaskLabel[]>();

    constructor(){}

    removeLabel(label: TaskLabel){
        this.labels = this.labels.filter(l => l.id !== label.id);
        this.onLabelChange.emit(this.labels);
    }

}

